<template>
    <div class="txt-container" v-if="quick_text" :style="style">
        {{quick_text.content.text}}
    </div>
</template>

<script>

export default {
  name: 'QuickText',
  components: {
    
  },
  data(){
    return {
        style:null,
        BOLD_YES:1,
        UNDERLINE_YES:1,
        ITALIC_YES:1
    }
  },
  props: {
    quick_text: null
  },
  methods:{
    
  },
  created(){

    const alignments=['left','center','right'];
    
    this.style={
        'font-size':this.quick_text.content.font_size+'px',
        color:this.quick_text.content.color,
        'font-weight':this.quick_text.content.bold==this.BOLD_YES?'bold':'normal',
        'text-decoration':this.quick_text.content.underline==this.UNDERLINE_YES?'underline':'normal',
        'font-style':this.quick_text.content.italic==this.ITALIC_YES?'italic':'normal',
        'text-align':alignments[this.quick_text.content.alignment-1]
      };

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.txt-container{
    padding:20px 10px;
}
</style>